import {
  type ActiveWarrantyInfo,
  getActiveWarrantyVersion,
  getWarrantyInternalTooltip,
  isWarrantyEnabled,
} from '@/utils/migration/warranty-version';

import { useMe } from './use-me';

export type WarrantyVersionInfo = ActiveWarrantyInfo & {
  /** Tooltip text explaining version state for internal users */
  internalTooltip: string;
};

/**
 * Hook to get the active warranty version info.
 * Uses the single source of truth from warranty-version.ts
 */
export function useWarrantyVersion(): WarrantyVersionInfo | null {
  const me = useMe();
  const activeVersion = getActiveWarrantyVersion(
    me.config.featureFlags,
    me.isInternal,
  );

  if (!activeVersion) {
    return null;
  }

  return {
    ...activeVersion,
    internalTooltip: getWarrantyInternalTooltip(
      me.config.featureFlags,
      me.tenant,
    ),
  };
}

/**
 * Hook to check if any warranty feature is enabled.
 */
export function useIsWarrantyEnabled(): boolean {
  const me = useMe();
  return isWarrantyEnabled(me.config.featureFlags, me.isInternal);
}
